import * as r from "react";
import t from "../lib/SSRBase.es.js";
import a from "../defs/Browser.es.js";
const o = r.forwardRef((e, s) => /* @__PURE__ */ r.createElement(t, { ref: s, ...e, weights: a }));
o.displayName = "BrowserIcon";
const f = o;
export {
  f as Browser,
  o as BrowserIcon
};
